export default {
    namespaced: true,
    state: {
        snackbar: {
            show: false,
            text: '',
            type: 'lang',
            timeout: 5000
        }
    },
    mutations: {
        SET_SNACKBAR(state, options) {
            for (const i in options) {
                state.snackbar[i] = options[i];
            }
        }
    },
    actions: {
        setSnackbar(context, options) {
            context.commit('SET_SNACKBAR', options);
        }
    }
};
